//Hide and show password complexity Module
/*
 * Dependencies
 */
var $ = require('jquery');
/*
 * Main class
 */
var passwordValidationHandler = {
  /**
  * This function is used to initialize password module and calls validatePasswordField function
  * @param {Object} $this jQuery object of dom element
  * @param {Object} options Various options passed
  * @returns {boolean} Operation succeeded or not
  */
  initialize: function($this, options) {
    var passwordModule;
    options = options || {};
    passwordModule = $this.find(options.passwordModuleSelector || '.m-pswd-info');
    if (passwordModule.length) {
      this.validatePasswordField($this, options);
    }
    return true;
  },
  /**
  * This function is used to set up validation criteria and attach callback on changing
  * password and confirm password field.
  * @param {Object} $this jQuery object of dom element
  * @param {Object} options Various options passed
  * @returns {boolean} Operation succeeded or not
  */
  validatePasswordField: function _validatePasswordField($this, options) {
    var validateConfirmPassword = false,
      defaultPasswordModuleSelector = '.m-pswd-info',
      defaultPasswordIconSelector = '.js-icon-presubmit i, label[for=\'password\'] i',
      defaultConfirmPasswordIconSelector = '.js-confirmicon-presubmit i, label[for=\'confirmPassword\'] i, label[for=\'passwordConfirmation\'] i',
      passwordFieldSelector = '.js-field-password',
      confirmPasswordFieldSelector = '.js-field-password-confirmation',
      iconSelector = '.t-icon',
      labelIconSelector = '.label-icon',
      labelConfirmIconSelector = '.label-confirm-icon',
      passwordLabelSelector = 'label[for=\'password\'] #passwordLabel',
      activeLabelSelector = '#label-activate span',
      labelIconElementSelector = '.label-icon i',
      formGroupSelector = '.l-form-group',
      confirmPasswordLabelSelector = 'label[for=\'confirmPassword\'] #confirmPasswordLabel',
      confirmActivateLabel = '#label-confirm-activate span',
      labelConfirmIconElementSelector = '.label-confirm-icon i',
      passwordModule = $this.find(options.passwordModuleSelector || defaultPasswordModuleSelector),
      removeConfirmAsterisk = $this.find(defaultConfirmPasswordIconSelector),
      addPasswordIcon = $this.find(options.passwordIconSelector || defaultPasswordIconSelector),
      addConfirmPasswordIcon = $this.find(options.confirmPasswordIconSelector || defaultConfirmPasswordIconSelector),
      passwordField = $this.find(passwordFieldSelector),
      confirmPasswordField = $this.find(confirmPasswordFieldSelector),
      errorClasses = options.errorClasses || 't-form-error icon-error',
      successClasses = options.successClasses || 't-form-success icon-success',
      asteriskClasses = 'icon-asterisk t-form-asterisk',
      hiddenClass = 'is-hidden',
      screenReaderClass = 'is-screenreader-only',
      formErrorClass = 't-form-error',
      formSuccessClass = 't-form-success',
      fieldErrorClass = 'is-error',
      fieldDisabledClass = 'is-disabled',
      formIcon = '<i class="icon"></i>',
      isCriteriaMet = false,
      passwordValidationCriteria = {
        length: {
          $el: $this.find('#password-length'),
          validate: function(value) {
            return value.length >= 8;
          }
        },
        lowercase: {
          $el: $this.find('#password-lower'),
          validate: function(value) {
            return value.match(/[a-z]/g);
          }
        },
        capitalLetter: {
          $el: $this.find('#password-upper'),
          validate: function(value) {
            return value.match(/[A-Z]/g);
          }
        },
        specialChars: {
          $el: $this.find('#password-number'),
          validate: function(value) {
            var char;
            if (value.match(/[\d!@#$&%=_?]/g)) {
              char = value.match(/[\d!@#$&%=_?]/g);
            }
            if (value.match(/[^a-zA-Z\d!@#$&%=_?]/g)) {
              char = value.match(/\[]/g);
            }
            return char;
          }
        }
      },
      KEYCODE = {
        TAB: 9
      };

    $this.find(labelIconSelector).prepend(formIcon);
    $this.find(labelConfirmIconSelector).prepend(formIcon);

    $this.find(passwordFieldSelector + ', ' + confirmPasswordFieldSelector).keyup(function(e) {
      var passwordComplex = passwordField.val(),
      passwordConfirmation = confirmPasswordField.val(),
      valueCriteria = null,
      criteria = null,
      isValid = true,
      metCriteriaMessage = passwordModule.data('met-criteria-message'),
      notMetCriteriaMessage = passwordModule.data('not-met-criteria-message');

      /**
      * This function is used to validate password
      * @returns {boolean} Operation succeeded or not
      */
      var validatePassword = function _validatePassword() {
        for (criteria in passwordValidationCriteria) {
          if (passwordValidationCriteria.hasOwnProperty(criteria)) {
            valueCriteria = passwordValidationCriteria[criteria];
            if (valueCriteria.validate(passwordComplex)) {
              valueCriteria.$el.removeClass(formErrorClass).addClass(formSuccessClass);
              if (options.isLabelIcon === false && valueCriteria.$el.find(iconSelector).hasClass(errorClasses)) {
                valueCriteria.$el.find(iconSelector).removeClass(errorClasses).addClass(successClasses);
                valueCriteria.$el.find('.is-hidden-text').remove();
                valueCriteria.$el.prepend('<span class="is-hidden-text">' + metCriteriaMessage + '</span>');
              }
            } else {
              valueCriteria.$el.removeClass(formSuccessClass).addClass(formErrorClass);
              if (options.isLabelIcon === false && valueCriteria.$el.find(iconSelector).hasClass(successClasses)) {
                valueCriteria.$el.find(iconSelector).removeClass(successClasses).addClass(errorClasses);
                valueCriteria.$el.find('.is-hidden-text').remove();
                valueCriteria.$el.prepend('<span class="is-hidden-text">' + notMetCriteriaMessage + '</span>');
              }
              isValid = false;
            }
          }
        }
        return true;
      }
      /**
      * This function is used to perform actions after validating password
      * @returns {boolean} Operation succeeded or not
      */
      var postPasswordValidation = function _postPasswordValidation() {
        if (isValid) {
          if (options.isLabelIcon !== false) {
            passwordModule.addClass(hiddenClass);
            addPasswordIcon.removeClass(asteriskClasses);
            $this.find(passwordLabelSelector).html('Password');
            $this.find(activeLabelSelector).remove('*');
            $this.find(labelIconElementSelector).addClass(successClasses).removeClass(errorClasses);
          } else {
            // set criteria met to true and add class for accessibility only once
            if (!isCriteriaMet) {
              isCriteriaMet = true;
              passwordModule.addClass(screenReaderClass);
            }
          }
          addPasswordIcon.addClass(successClasses).removeClass(errorClasses);
          passwordField.removeClass(fieldErrorClass);
          confirmPasswordField.prop('disabled', false);
          confirmPasswordField.removeClass(fieldDisabledClass);
          //Remove grey background color condition for CN domain start
          if($('.is-mobile-auth').length > 0) {
          confirmPasswordField.removeClass("t-bg-standard-30");
          }
          //Remove grey background color condition for CN domain End
        } else {
          if (options.isLabelIcon !== false) {
            addPasswordIcon.removeClass(asteriskClasses);
            $this.find(passwordLabelSelector).html('Password');
            $this.find(activeLabelSelector).remove('*');
            $this.find(labelIconElementSelector).removeClass(successClasses).addClass(errorClasses);
          }
          if(passwordModule.hasClass(screenReaderClass)) {
            passwordModule.removeClass(screenReaderClass);
          } else {
            passwordModule.removeClass(hiddenClass);
          }
          // set criteria met to false as criteria is now not met
          isCriteriaMet = false;
          addPasswordIcon.addClass(errorClasses).removeClass(successClasses);
          passwordField.addClass(fieldErrorClass);
          confirmPasswordField.prop('disabled', true);
          confirmPasswordField.addClass(fieldDisabledClass);
          //Adding grey background color condition for CN domain start
          if($('.is-mobile-auth').length > 0) {
          confirmPasswordField.addClass("t-bg-standard-30");
          }
          //Adding grey background color condition for CN domain end
          passwordField.focus();
        }
        return true;
      }
      /**
      * This function is used to perform actions after validating confirm password field
      * @returns {boolean} Operation succeeded or not
      */
      var postConfirmPasswordValidation = function _postConfirmPasswordValidation() {
        if (passwordComplex === passwordConfirmation && passwordConfirmation.length > 0 && isValid === true) {
          if (options.isLabelIcon !== false) {
            removeConfirmAsterisk.removeClass(asteriskClasses);
            $this.find(confirmPasswordLabelSelector).html('Confirm Password');
            $this.find(confirmActivateLabel).remove('*');
            $this.find(labelConfirmIconElementSelector).addClass(successClasses).removeClass(errorClasses);
          }
          addConfirmPasswordIcon.addClass(successClasses).removeClass(errorClasses);
          confirmPasswordField.removeClass(fieldErrorClass);
        } else {
          if (options.isLabelIcon !== false) {
            removeConfirmAsterisk.removeClass(asteriskClasses);
            $this.find(confirmPasswordLabelSelector).html('Confirm Password');
            $this.find(confirmActivateLabel).remove('*');
            $this.find(labelConfirmIconElementSelector).removeClass(successClasses).addClass(errorClasses);
          }
          addConfirmPasswordIcon.addClass(errorClasses).removeClass(successClasses);
          confirmPasswordField.addClass(fieldErrorClass);
        }
        return true;
      }

      if (e.which !== KEYCODE.TAB) {
        validatePassword();
        postPasswordValidation();
        if (validateConfirmPassword) {
          postConfirmPasswordValidation();
        }
      }
    });
    confirmPasswordField.on('focus', function(e) {
      e.preventDefault();
      validateConfirmPassword = true;
    });
    passwordField.on('focus', function(e) {
      e.preventDefault();
      passwordModule.removeClass(hiddenClass);
    });
    passwordField.on('blur', function(e) {
      e.preventDefault();
      passwordModule.addClass(hiddenClass);
      if(passwordModule.hasClass(screenReaderClass)) {
        passwordModule.removeClass(screenReaderClass);
      }
    });
    return true;
  }
};

module.exports = passwordValidationHandler;
